import React from 'react';
import PropTypes from 'prop-types';
import Actions from 'components/ui/general/Actions';
import Breadcrumbs from 'components/layout/Layout/Breadcrumbs';
import Card from 'components/ui/card/Card';
import CardText from 'components/ui/card/CardText';
import Header from 'components/ui/general/Header';
import ListButton from 'components/button/ListButton';
import ProductsEdit from './ProductsEditForm';
import Title from 'components/ui/general/Title';
import compose from 'recompose/compose';
import fetchResourceById from 'components/hoc/fetchResourceById';
import translate from 'components/hoc/translate';
import { connect } from 'react-redux';
import { fetchProduct } from 'store/actions/products/fetchProducts';
import { updateProduct } from 'store/actions/products/updateProducts';
import LoadingCard from 'components/loading/LoadingCard';
import ResourceNotFound from 'pages/NotFound/ResourceNotFound';

class ProductsEditContainer extends React.Component {
    handleSubmitForm = (values) => {
        const {
            dispatchForm,
            history,
            id,
        } = this.props;

        return new Promise((resolve) => {
            dispatchForm({
                onError: () => {
                    // This location should have where we bounce the error back to the form with SubmissionError.
                    resolve();
                },
                onSuccess: () => {
                    resolve(history.push(`/products/${ id }/show`));
                },
                values: values,
                id: id,
            });
        });
    }

    render() {
        const {
            data,
            resourceFetchFailed,
            resourceFetchLoading,
            translate,
        } = this.props;

        if (resourceFetchLoading) {
            return <LoadingCard />;
        }

        if (resourceFetchFailed) {
            return <ResourceNotFound />;
        }

        const breadcrumbs = [
            {
                label: translate('resources.products.title'),
                link: '/products',
            },
            {
                label: data.title,
                link: `/products/${ data.id }/show`,
            },
            {
                label: translate('actions.edit'),
            },
        ];

        return (
            <div>
                <Breadcrumbs breadcrumbs={ breadcrumbs } />

                <Header>
                    <Title title={ translate('resources.products.actions.edit') } />

                    <Actions>
                        <ListButton url='/products' />
                    </Actions>
                </Header>

                <Card>
                    <CardText>
                        <ProductsEdit
                            data={ data }
                            form='products_edit'
                            handleSubmitForm={ this.handleSubmitForm }
                        />
                    </CardText>
                </Card>
            </div>
        );
    }
}

ProductsEditContainer.propTypes = {
    data: PropTypes.object,
    dispatchForm: PropTypes.func.isRequired,
    history: PropTypes.object,
    id: PropTypes.string,
    resourceFetchFailed: PropTypes.bool.isRequired,
    resourceFetchLoading: PropTypes.bool.isRequired,
    translate: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchForm: (values) => {
            dispatch(updateProduct(values));
        },
    };
};

const enhance = compose(
    translate,
    connect(
        null,
        mapDispatchToProps,
    ),
    fetchResourceById({
        resource: 'products',
        action: fetchProduct,
    })
);

export default enhance(ProductsEditContainer);



// WEBPACK FOOTER //
// ./src/pages/products/edit/ProductsEditContainer.js